import { HttpErrorResponse } from '@angular/common/http';

export const PROFILE_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const PROFILE_IMAGE_TYPES = ['image/png', 'image/jpeg'];
export const PROFILE_IMAGE_ACCEPT = PROFILE_IMAGE_TYPES.join(',');

export const IMAGE_TYPE_MESSAGE = 'Only JPG or PNG images are allowed.';
export const IMAGE_SIZE_MESSAGE = 'The image must be 5 MB or smaller.';
export const IMAGE_EMPTY_MESSAGE = 'The selected image is empty.';
export const IMAGE_FAILED_MESSAGE = 'The image could not be uploaded. Please try again.';

/** Why a file cannot be used as a Base profile image, or null when it is fine. */
export function validateProfileImage(file: File): string | null {
  if (!PROFILE_IMAGE_TYPES.includes(file.type)) return IMAGE_TYPE_MESSAGE;
  if (file.size === 0) return IMAGE_EMPTY_MESSAGE;
  if (file.size > PROFILE_IMAGE_MAX_BYTES) return IMAGE_SIZE_MESSAGE;
  return null;
}

/** Fixed wording for a rejected upload (413 too large, 415 wrong type, 400 empty). */
export function profileImageUploadError(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    if (error.status === 413) return IMAGE_SIZE_MESSAGE;
    if (error.status === 415) return IMAGE_TYPE_MESSAGE;
    if (error.status === 400) return IMAGE_EMPTY_MESSAGE;
  }
  return IMAGE_FAILED_MESSAGE;
}
